import {
  HeadingText,
  BodyText,
  Checkbox,
  Button,
  Row,
  Col,
  Alert,
  TextArea,
  LoadingSpinner,
  Container,
} from '@paypalcorp/pp-react'
import { string, bool } from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { React, Fragment, memo, useState, useEffect } from 'react'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'
import serverData from '../../../utils/server-data'
import { DATA_DELETION_SUBMIT_URL } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import asASlide from '../../common/as-a-slide'
const { locality = {} } = serverData
const directionality = locality.directionality || 'ltr'
const maxCharacters = 2500

const DeletionFeedback = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION
  const deletionFptiCHECKBOX = DATAPRIVACY_FPTI.DELETION.CHECKBOX
  const [impressionDone, setImpressionDone] = useState(false)
  const [tooManyEmails, setTooManyEmails] = useState(props.tooManyEmails)
  const [otherReasons, setOtherReasons] = useState(props.otherReasons)
  const [concernedDataPrivacy, setConcernedDataPrivacy] = useState(
    props.concernedDataPrivacy,
  )
  const [onlyPPaccount, setOnlyPPaccount] = useState(props.onlyPPaccount)
  const [anotherPPaccount, setAnotherPPaccount] = useState(
    props.anotherPPaccount,
  )
  const [comments, setComments] = useState(props.comments)

  const [showSpinner, setShowSpinner] = useState(props.showSpinner)
  const [showAlert, setShowAlert] = useState(props.showAlert)
  const [isValidRequest, setIsValidRequest] = useState(false)

  const {
    onModalNavigate,
    updateModalStore,
    modalParams: {
      s_anotherPPaccount = false,
      s_onlyPPaccount = false,
      s_concernedDataPrivacy = false,
      s_otherReasons = false,
      s_tooManyEmails = false,
      storedComment = '',
    } = {},
  } = props

  const validateMandatoryCheck = () => {
    let isValidReq = false
    if (
      (anotherPPaccount ||
        onlyPPaccount ||
        concernedDataPrivacy ||
        otherReasons ||
        tooManyEmails) &&
      maxCharacters >= comments.length
    ) {
      isValidReq = true
    }
    return isValidReq
  }

  async function handleSubmitClick(event) {
    event.preventDefault()
    fptiCustomClick(deletionFpti.SUBMIT_BTN)

    const isValid = validateMandatoryCheck()
    if (!isValid) {
      setShowAlert(true)
    } else {
      setShowAlert(false)
      const reqparams = {
        _csrf: serverData._csrf,
        comment: comments,
        p_anotherPPaccount: anotherPPaccount,
        p_onlyPPaccount: onlyPPaccount,
        p_concernedDataPrivacy: concernedDataPrivacy,
        p_tooManyEmails: tooManyEmails,
        p_otherReasons: otherReasons,
        deletionEmail: serverData.deletionEmail || '',
      }
      postDeletionRequest(reqparams)
    }
  }

  async function postDeletionRequest(reqparams) {
    setShowSpinner(true)

    const checkResponseMsg = (response) => {
      if (response && response.data && response.data.msg === 'success') {
        onModalNavigate(4)
      } else {
        location.href = response && response.data && response.data.redirect
      }
    }

    const response = await post(DATA_DELETION_SUBMIT_URL, reqparams)
    if (response.success) {
      setShowAlert(false)
      setIsValidRequest(false)
      checkResponseMsg(response)
    } else {
      setShowSpinner(false)
      updateModalStore({ submitError: true })
      onModalNavigate(0)
    }
  }

  const onCommentChange = (event) => {
    const value = event.target.value
    setComments(value)
    updateModalStore({ storedComment: value })
  }

  // eslint-disable-next-line complexity
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(deletionFpti.FEEDBACK_IMPRESSION)
    }
    const params = serverData.deletionReqParams || null
    if (params && props.redirect === 'authweb') {
      postDeletionRequest(params)
    }
    const {
      p_anotherPPaccount,
      p_onlyPPaccount,
      p_concernedDataPrivacy,
      p_otherReasons,
      p_tooManyEmails,
      comment,
    } = params || {}
    setAnotherPPaccount(p_anotherPPaccount || s_anotherPPaccount || false)
    setOnlyPPaccount(p_onlyPPaccount || s_onlyPPaccount || false)
    setConcernedDataPrivacy(
      p_concernedDataPrivacy || s_concernedDataPrivacy || false,
    )
    setOtherReasons(p_otherReasons || s_otherReasons || false)
    setTooManyEmails(p_tooManyEmails || s_tooManyEmails || false)
    setComments(comment || storedComment || '')
  }, [])

  const onCheckboxClick = (event) => {
    const value = event.target.value

    const isChecked = event.target.checked

    if (isChecked && deletionFptiCHECKBOX.link) {
      deletionFptiCHECKBOX.link.length = 0
      deletionFptiCHECKBOX.link.push(value)
      fptiCustomClick(deletionFptiCHECKBOX)
    }
    const targetID = event.target.id
    if (targetID === 'another_pp_account') {
      setAnotherPPaccount(!anotherPPaccount)
      updateModalStore({ s_anotherPPaccount: !anotherPPaccount })
    }
    if (targetID === 'only_pp_account') {
      setOnlyPPaccount(!onlyPPaccount)
      updateModalStore({ s_onlyPPaccount: !onlyPPaccount })
    }
    if (targetID === 'concerned_data_privacy') {
      setConcernedDataPrivacy(!concernedDataPrivacy)
      updateModalStore({ s_concernedDataPrivacy: !concernedDataPrivacy })
    }
    if (targetID === 'too_many_mails') {
      setTooManyEmails(!tooManyEmails)
      updateModalStore({ s_tooManyEmails: !tooManyEmails })
    }
    if (targetID === 'other_reasons') {
      setOtherReasons(!otherReasons)
      updateModalStore({ s_otherReasons: !otherReasons })
    }
  }
  return (
    <Fragment>
      {showSpinner ? (
        <div>
          <div className="requestForm-spinner">
            <LoadingSpinner screenReaderText="loading" size="lg" />
          </div>
        </div>
      ) : (
        <Container form>
          {showAlert && (
            <Alert
              className="requestForm-row"
              type="error"
              closeButton={{
                onClick: () => {
                  setShowAlert(false)
                  setIsValidRequest(false)
                },
              }}
            >
              <Message
                id={
                  isValidRequest
                    ? 'dar.header.alert.fail'
                    : 'dar.section.submit.fail'
                }
              />
            </Alert>
          )}

          <HeadingText id="feedbackHeader" size="sm">
            <Message id="dataErasure.section.feedbackHeading" />
          </HeadingText>
          <BodyText className="dataPrivacy-row">
            <Message id="dataErasure.section.feedbackDesc" />
          </BodyText>
          <Row className="dataPrivacy-row">
            <Col dir={directionality}>
              <Checkbox
                id="another_pp_account"
                name="option"
                value="I have another PayPal account"
                checked={anotherPPaccount}
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackone" />}
              />
              <Checkbox
                name="option"
                id="only_pp_account"
                className="feedback-checkbox"
                value="This is my only PayPal account, but I don't use it"
                checked={onlyPPaccount}
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackTwo" />}
              />

              <Checkbox
                name="option"
                id="concerned_data_privacy"
                className="feedback-checkbox"
                value="I'm concerned about data privacy"
                checked={concernedDataPrivacy}
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackThree" />}
              />

              <Checkbox
                name="option"
                id="too_many_mails"
                className="feedback-checkbox"
                value="I receive too many emails and notifications"
                checked={tooManyEmails}
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackFour" />}
              />

              <Checkbox
                name="option"
                id="other_reasons"
                className="feedback-checkbox"
                value="Other reasons (please specify below)"
                checked={otherReasons}
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackFive" />}
              />
            </Col>
          </Row>
          <Row className="dataPrivacy-row">
            <Col dir={directionality}>
              <TextArea
                name="comment"
                id="add_comments"
                value={comments}
                onChange={onCommentChange}
                label={<Message id="dataErasure.section.addCommentLabel" />}
                showCharacterCounter
                maxCharacters={maxCharacters}
                maxLength={maxCharacters}
              />
            </Col>
          </Row>
          <Row className="dataPrivacy-btn-row">
            <Col sm={6} md={6}>
              <Button
                id="submitBtn"
                size="ld"
                onClick={handleSubmitClick}
                className="dataPrivacy-btn-fullwidth"
              >
                <Message id="dataErasure.section.submitRequest" />
              </Button>
            </Col>
          </Row>
        </Container>
      )}
    </Fragment>
  )
})

DeletionFeedback.propTypes = {
  comments: string,
  otherReasons: bool,
  tooManyEmails: bool,
  concernedDataPrivacy: bool,
  onlyPPaccount: bool,
  anotherPPaccount: bool,
  showSpinner: bool,
  showAlert: bool,
}
DeletionFeedback.defaultProps = {
  comments: '',
  otherReasons: false,
  tooManyEmails: false,
  concernedDataPrivacy: false,
  onlyPPaccount: false,
  anotherPPaccount: false,
  showSpinner: false,
  showAlert: false,
}
DeletionFeedback.displayName = 'DeletionFeedback'
export default asASlide({ position: 3 })(DeletionFeedback)
